module.exports = __webpack_public_path__ + "img/電気回路_3_1_2.a792fbc8.png";